// Marketplace Status Badge Component
// Feature: 006-marketplace-management

import { useTranslation } from 'react-i18next';
import type { MarketplaceItemStatus } from '@/types/marketplaceAdmin';
import { CheckCircle, Clock, Trash2 } from 'lucide-react';

interface MarketplaceStatusBadgeProps {
  status: MarketplaceItemStatus;
  className?: string;
}

export function MarketplaceStatusBadge({ status, className = '' }: MarketplaceStatusBadgeProps) {
  const { t } = useTranslation('marketplaceAdmin');

  const statusConfig: Record<MarketplaceItemStatus, { label: string; icon: typeof CheckCircle; className: string }> = {
    active: {
      label: t('status.active'),
      icon: CheckCircle,
      className: 'bg-green-100 text-green-800 border-green-200',
    },
    expired: {
      label: t('status.expired'),
      icon: Clock,
      className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    },
    deleted: {
      label: t('status.deleted'),
      icon: Trash2,
      className: 'bg-red-100 text-red-800 border-red-200',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium border ${config.className} ${className}`}
    >
      <Icon size={14} />
      {config.label}
    </span>
  );
}
